const SiteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY
const ApiUrl = process.env.INTERNAL_API_URL || process.env.NEXT_PUBLIC_API_URL
const ImageUrl = process.env.NEXT_PUBLIC_API_URL + '/'
const VerifyUrl = process.env.NEXT_PUBLIC_APP_URL
const NEXTAUTH_SECRET = process.env.NEXTAUTH_SECRET
const TOKEN_HEADER = process.env.NEXT_PUBLIC_TOKEN_HEADER
const NODE_ENV = process.env.NEXT_PUBLIC_NODE_ENV
export {
  ImageUrl,
  SiteKey,
  ApiUrl,
  VerifyUrl,
  NEXTAUTH_SECRET,
  TOKEN_HEADER,
  NODE_ENV,
}
